var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "render",
      style: { background: "#" + _vm.backgroundProp },
      attrs: { id: "renderContainer" }
    },
    [
      _c(
        "div",
        {
          staticClass: "canvas",
          style: {
            transform:
              "translate3d(" +
              _vm.canvas.endx +
              "px, " +
              _vm.canvas.endy +
              "px, 0)"
          },
          on: { mousedown: _vm.canvasDragStart }
        },
        [
          _c("img", {
            staticClass: "image radiator",
            staticStyle: { "transform-origin": "center center" },
            style: { transform: "scale(" + _vm.zoomScale + ")" },
            attrs: {
              src:
                "https://s3-eu-west-1.amazonaws.com/bisque-media/renders/" +
                _vm.renderCodeProp +
                "/" +
                _vm.renderCodeProp +
                "_" +
                _vm.finishProp.renderReference +
                "_" +
                _vm.settings.view +
                ".png",
              alt: ""
            },
            on: { error: _vm.radiatorRenderError }
          })
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "controls" }, [
        _c("ul", { staticClass: "views" }, [
          _c(
            "li",
            {
              staticClass: "view btn",
              on: {
                click: function($event) {
                  return _vm.viewSelected("Front")
                }
              }
            },
            [_vm._v("Front")]
          ),
          _vm._v(" "),
          _c(
            "li",
            {
              staticClass: "view btn",
              on: {
                click: function($event) {
                  return _vm.viewSelected("Side")
                }
              }
            },
            [_vm._v("Side")]
          )
        ]),
        _vm._v(" "),
        _c("ul", { staticClass: "zooms" }, [
          _c("li", { staticClass: "zoom btn", on: { click: _vm.zoomIn } }, [
            _vm._v("+")
          ]),
          _vm._v(" "),
          _c("li", { staticClass: "zoom btn", on: { click: _vm.zoomOut } }, [
            _vm._v("-")
          ])
        ]),
        _vm._v(" "),
        _c("ul", { staticClass: "backgrounds" }, [
          _c(
            "li",
            {
              staticClass: "background-colour btn",
              on: { click: _vm.toggleBackgroundPicker }
            },
            [_vm._v("Background colour")]
          )
        ]),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "colour-picker",
            class: { hidden: !_vm.backgroundPickerOpen }
          },
          [
            _c("ColorPicker", {
              attrs: {
                width: 195,
                height: 195,
                disabled: !_vm.backgroundPickerOpen,
                startColor: _vm.backgroundProp
              },
              on: { "color-change": _vm.onBackgroundChanged }
            })
          ],
          1
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }